export default __webpack_public_path__ + "static/media/content3-transparent.181872b0.png";